import src from "IMAGE";
export default { src, width: 247, height: 48, blurWidth: 0, blurHeight: 0};
